import script from "./InputRadio.vue?vue&type=script&setup=true&lang=js"
export * from "./InputRadio.vue?vue&type=script&setup=true&lang=js"

import "./InputRadio.vue?vue&type=style&index=0&id=6f943bcf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f943bcf"]])

export default __exports__